// @ts-nocheck
import {
    chain,
    SelectVariantProduct as BaseSelectVariantProduct,
} from "@insite/client-framework/Store/Components/ProductSelector/Handlers/UpdateVariantSelection";
import { getProductSelector } from "@insite/client-framework/Store/Components/ProductSelector/ProductSelectorSelectors";
import {
    getProductState,
    getVariantChildrenDataView,
} from "@store/Modules/client-framework/src/Store/Data/Products/ProductsSelectors";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const SelectVariantProduct = createChainHandler("SelectVariantProduct", chain, props => {
    const state = props.getState();
    const productState = getProductState(state, getProductSelector(state).variantModalProductId);

    if (!props.variantSelectionCompleted) {
        return;
    }

    const variantChildren = getVariantChildrenDataView(state, productState.value).value!; // Store Custom Code

    for (const variantChild of variantChildren) {
        let matches = true;
        if (!variantChild.childTraitValues) {
            break;
        }
        for (const childTraitValue of variantChild.childTraitValues) {
            if (props.variantSelection[childTraitValue.styleTraitId] !== childTraitValue.id) {
                matches = false;
                break;
            }
        }

        if (matches) {
            props.selectedProductId = variantChild.id;
            return;
        }
    }
});

replaceInChain(chain, BaseSelectVariantProduct, SelectVariantProduct);
